import Menu from "./ItalyMenu";
import Footer from "../../Components/Footer";
import { Outlet } from "react-router-dom";
import styles from "../../Styles/Trip.module.scss";


function ItalyTrip() {


  return (
    <div>
      <div className={`${styles.menuPosition} ${styles.container}`}>
        <Menu />
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ItalyTrip;